import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import SectionCard from '../shared/SectionCard'
import './style.css'
import { generator } from '@/utils/NumbersUtils'
import { Block } from '@/components/crRender'
import { Fragment } from 'react'
import TechDataRow from './DataRow'
import ActionBtn from '@/components/ActionBtn'

const createTechnology = () => ({
    id: generator.key(),
    name: '',
    description: '',
    nameEN: '',
    descriptionEN: '',
    picture: null,
    attachmentPath: null
})


const EditAdvancedTechs = ({ formHandler, providerInfo, isLoading }) => {

    const { t } = useTranslation()
    const [technologies, setTechnologies] = useState(providerInfo?.technologies || [])
    const { handleFormValues } = formHandler


    useEffect(() => {
        if(providerInfo?.technologies?.length){
            setTechnologies(providerInfo?.technologies.map((tech ,index) => ({...tech ,id :tech?.id||tech?.attachmentId ||index  })) )
        }
    }, [providerInfo])


    const addTechnology = () => {
        const newTech = createTechnology()
        const updatedTechs = [...technologies, newTech]
        setTechnologies(updatedTechs)
        handleFormValues('technologies', updatedTechs)
    }

    const removeTechnology = (id) => {
        const updatedTechs = technologies.filter(tech => tech.id !== id)
        setTechnologies(updatedTechs)
        handleFormValues('technologies', updatedTechs)
    }

    const updateTechnology = (id, field, value) => {
        const updatedTechs = technologies.map(tech =>
            tech.id  == id ? { ...tech, [field]: value } :{...tech}
        )
        setTechnologies(updatedTechs)
        handleFormValues('technologies', updatedTechs)
    }


    return (
        <SectionCard
            title={t("advanced-technologies")}
            icon="streamline:ai-technology-spark-remix"
            className="edit-advanced-techs" >

            <div className="advanced-techs-container">
                <div className="techs-header">
                    <ActionBtn
                        className="btn-primary add-technology-btn m-0"
                        onApply={addTechnology}
                        title={t("add-technology")}
                        icon="mdi:plus-circle" />
                </div>

                <div className="row ">
                    {technologies?.map((tech ,index) =>
                        <Fragment key={tech?.id }>
                            <TechDataRow
                                removeTechnology={removeTechnology}
                                updateTechnology={updateTechnology}
                                tech={tech} formHandler={formHandler} isLoading={isLoading} />
                        </Fragment>
                    )}

                    <Block isRender={technologies.isEmpty()} className="empty-state col-md-12">
                        <Icon icon="mdi:robot-outline" className="empty-icon" />
                        <p>{t("no-technologies-added")}</p>
                        <p className="empty-hint">{t("click-add-technology-to-start")}</p>
                    </Block>
                </div>
            </div>
            
        </SectionCard>
    )
}

export default EditAdvancedTechs

